import {useContext, useMemo} from 'react';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useGetWineShopListQuery} from 'modules/wineshops-list/services';
import {ProductPageContext} from 'modules/product-card/context';
import {getProductCentralStoresWithStock} from 'modules/wineshops-list/helpers';
import {SECTION_CODE} from 'modules/product-card/constants';

export const useProductReceivingMethods = () => {
    const {
        expressWineshop: userWineshop,
        isExpressWineshopLoading,
        wineshopsForTodayWithStock,
    } = useContext(ProductPageContext);

    const {isFetching: isWineshopListLoading} = useGetWineShopListQuery();

    const productData = useAppSelector(selectProductData);

    const currentStockType = productData?.vintages.find((item) => item.code === productData?.code)?.stockType;

    const isUserWineshopTodayWarning = useMemo(
        () =>
            !isExpressWineshopLoading &&
            !isWineshopListLoading &&
            userWineshop &&
            !wineshopsForTodayWithStock.some((wineshop) => wineshop.warehouseCode === userWineshop.warehouseCode),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [userWineshop, wineshopsForTodayWithStock, isExpressWineshopLoading, isWineshopListLoading],
    );

    // https://kb.simple.ru/pages/viewpage.action?pageId=147068680
    const showPickupToday = useMemo(() => {
        return 0 < wineshopsForTodayWithStock.length && productData?.topSection !== SECTION_CODE.VODA_I_SOKI;
    }, [productData?.topSection, wineshopsForTodayWithStock.length]);

    const shopPickupTomorrow = useMemo(() => {
        return 0 < getProductCentralStoresWithStock(productData).length && 'WINERY_ONLY' !== currentStockType;
    }, [productData, currentStockType]);

    return {
        showPickupToday,
        shopPickupTomorrow,
        isUserWineshopTodayWarning,
    };
};
